document.addEventListener('DOMContentLoaded', async function () {
  document.addEventListener('click', onQtyButtonClick);
  document.addEventListener('change', onCheckboxChange);
  document.addEventListener('input', onQtyInput);

  try { await injectRecommended(); } catch(e) {}

  initBundle();
  recalculateTotal();
});

function getMeta() {
  const root = document.querySelector('.section--bundle');
  return {
    currency: root?.dataset.currency || 'USD',
    locale:   root?.dataset.locale   || 'en'
  };
}
const { currency, locale } = getMeta();

const fmtMoney = (cents) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency }).format((cents || 0) / 100);

function getCents(el, key) {
  const v = el?.dataset?.[key];
  if (v != null && /^\d+$/.test(String(v))) return parseInt(v, 10);
  const fallbackKey = key.replace(/Cents$/, '').replace(/-cents$/, '');
  const raw = el?.dataset?.[fallbackKey];
  const n = Number(String(raw || '0').replace(/[^\d.-]/g, ''));
  return Math.round((n || 0) * 100);
}

function onQtyButtonClick(e) {
  const btn = e.target.closest('.fb-quantity__button, .fb-quantity__button-recommended');
  if (!btn) return;

  const wrap = btn.closest('.fb-quantity');
  const input = wrap?.querySelector('.fb-quantity__input');
  const cb = btn.closest('.fb-checkbox__item-wrapper')?.querySelector('.bundle-checkbox');
  if (!input || !cb) return;

  const op = btn.dataset.op || (btn.name === 'fb-plus' ? 'plus' : btn.name === 'fb-minus' ? 'minus' : '');
  let v = parseInt(input.value || '0', 10) || 0;

  if (op === 'plus')  { if (v === 0) cb.checked = true; v += 1; }
  if (op === 'minus' && v >= 1) { v -= 1; if (v === 0) cb.checked = false; }

  input.value = v;
  recalculateTotal();
}

function onCheckboxChange(e) {
  const cb = e.target.closest('.bundle-checkbox');
  if (!cb) return;
  const input = cb.closest('.fb-checkbox')?.querySelector('.fb-quantity__input');
  if (!input) return;
  if (cb.checked && (input.value === '' || input.value === '0')) input.value = '1';
  if (!cb.checked) input.value = '0';
  recalculateTotal();
}

function onQtyInput(e) {
  const input = e.target.closest('.fb-quantity__input');
  if (!input) return;
  let v = Math.max(0, parseInt(input.value || '0', 10) || 0);
  input.value = v;
  const cb = input.closest('.fb-checkbox')?.querySelector('.bundle-checkbox');
  if (cb) cb.checked = v > 0;
  recalculateTotal();
}

async function injectRecommended() {
  const info = document.querySelector('.product__info-container');
  const container = document.querySelector('.fb-checkboxes');
  if (!info || !container) return;

  const productId = info.dataset.productId;
  if (!productId) return;

  const presetIds = Array.from(document.querySelectorAll('.fb-checkbox')).map(el => el.dataset.productId);
  const root = window.Shopify?.routes?.root || '/';
  const url = `${root}recommendations/products?product_id=${productId}&limit=10&intent=related&section_id=generated-bundle`;

  const res = await fetch(url);
  if (!res.ok) return;
  const html = await res.text();

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const products = Array.from(doc.querySelectorAll('.fb-checkbox'));
  if (!products.length) return;

  const filtered = products.filter(el => !presetIds.includes(el.dataset.productId)).slice(0, 3);
  if (!filtered.length) return;

  filtered.forEach((el) => {
    const clone = el.cloneNode(true);
    clone.classList.add('fb-checkbox--recommended');

    if (!clone.querySelector('.fb-quantity')) {
      const quantityWrapper = document.createElement('div');
      quantityWrapper.classList.add('fb-checkbox__quantity');
      quantityWrapper.innerHTML = `
        <div class="quantity fb-quantity">
          <button class="quantity__button fb-quantity__button-recommended" type="button" data-op="minus">-</button>
          <input class="quantity__input fb-quantity__input" type="number" name="fb-quantity" value="0" min="0" step="1">
          <button class="quantity__button fb-quantity__button-recommended" type="button" data-op="plus">+</button>
        </div>`;
      const priceBox = clone.querySelector('.fb-checkbox__pricing');
      (priceBox || clone).appendChild(quantityWrapper);
    }

    container.appendChild(clone);
  });
}

function initBundle() {
  const mainEl = document.getElementById('bundle-main');
  const cbs = Array.from(document.querySelectorAll('.fb-checkbox .bundle-checkbox'));

  const discountEl = document.getElementById('bundle-discount');    
  const totalEl = document.getElementById('bundle-total-price');
  const youSaveEl = document.getElementById('bundle-you-save');    
  const discountAllLine = document.querySelector('.fb-line--discount');
  const discountSelectedLine = document.querySelector('.fb-savings');

  if (!mainEl || !discountEl || !totalEl || !youSaveEl || !discountAllLine || !discountSelectedLine) return;
  const mainDisc = getCents(mainEl, 'priceCents');
  const mainOrig = getCents(mainEl, 'originalPriceCents') || mainDisc;

  let bundleDisc = 0, bundleOrig = 0;
  cbs.forEach(cb => {
    const p = getCents(cb, 'priceCents');
    const o = getCents(cb, 'originalPriceCents') || p;
    bundleDisc += p;
    bundleOrig += o;
  });

  const sumDiscAll = mainDisc + bundleDisc;
  const sumOrigAll = mainOrig + bundleOrig;
  const discountAll = Math.max(0, sumOrigAll - sumDiscAll);

  discountEl.textContent = fmtMoney(discountAll);
  discountAllLine.classList.toggle('d-none', discountAll <= 0);
  totalEl.textContent = fmtMoney(0);
  youSaveEl.textContent = fmtMoney(0);
  discountSelectedLine.classList.add('d-none');
  const btnSel = document.getElementById('add-bundle');
  const errEl = document.getElementById('bundle-error');
  if (!btnSel || !errEl) return;

  function showError(msg) { errEl.textContent = msg || ''; }

  async function addOne(id, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Error adding item.');
    }
  }

async function addAll(items) {
  showError('');
  
  const cartNotification = document.querySelector('cart-notification');
  if (!cartNotification) {
    // Fallback to redirect if no cart notification component
    for (const it of items) {
      if (it.quantity > 0) await addOne(it.id, it.quantity);
    }
    window.location = '/cart';
    return;
  }

  // Add items with sections for cart notification
  const sections = cartNotification.getSectionsToRender().map(s => s.id);
  
  for (const it of items) {
    if (it.quantity <= 0) continue;
    
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: it.id,
        quantity: it.quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    });
    
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Error adding item.');
    }
    
    const parsedState = await res.json();
    cartNotification.renderContents(parsedState);
  }
}

  btnSel.addEventListener('click', (e) => {
    e.preventDefault();
    const selectedItems = cbs
      .filter(cb => cb.checked)
      .map(cb => {
        const qty = parseInt(cb.closest('.fb-checkbox')?.querySelector('.fb-quantity__input')?.value || '0', 10) || 0;
        return { id: cb.dataset.variantId, quantity: qty };
      })
      .filter(it => it.quantity > 0);

    if (!selectedItems.length) {
      showError('Please select at least one bundle item.');
      return;
    }

    addAll(selectedItems).catch(err => {
      console.error(err);
      showError(err.message || 'Error adding items.');
    });
  });
}

function recalculateTotal() {
  const cbs = Array.from(document.querySelectorAll('.fb-checkbox .bundle-checkbox'));
  const totalEl = document.getElementById('bundle-total-price');
  const youSaveEl = document.getElementById('bundle-you-save');
  const discountSelectedLine = document.querySelector('.fb-savings');
  const listEl  = document.getElementById('bundle-selected-list');

  let totalDisc = 0;
  let totalOrig = 0;  
  let listHtml  = '';

  cbs.forEach(cb => {
    if (!cb.checked) return;

    const wrap = cb.closest('.fb-checkbox');
    const qty = Math.max(0, parseInt(wrap?.querySelector('.fb-quantity__input')?.value || '0', 10) || 0);
    if (!qty) return;

    const price = getCents(cb, 'priceCents');
    const orig  = getCents(cb, 'originalPriceCents') || price;
    const title = cb.dataset.title || wrap?.querySelector('.fb-checkbox__title')?.textContent?.trim() || 'Item';

    totalDisc += price * qty;
    totalOrig += orig  * qty;

    listHtml += `
      <div class="fb-product-summary">
        <span class="fb-product-title">${title}</span>
        <span class="fb-product-total-price">${fmtMoney(price * qty)}</span>
      </div>`;
  });

  totalEl.textContent = fmtMoney(totalDisc);

  const selectedSaving = Math.max(0, totalOrig - totalDisc);
  youSaveEl.textContent = fmtMoney(selectedSaving);
  discountSelectedLine.classList.toggle('d-none', selectedSaving <= 0);

  if (listEl) listEl.innerHTML = listHtml;
}
